import styles from './info-grid.module.scss';
import Image from 'next/image';
import classNames from 'classnames';

export type InfoGridProps = {
    items: {
        label: string;
        description: string;
        image: {
            src: string;
            width: number;
            height: number;
        };
        backgroundColor?: string;
    }[];
};

const InfoGrid = ({ items }: InfoGridProps) => {
    return (
        <div className={styles['grid']}>
            {items.map((item, i) => (
                <div className={styles['item']} key={i}>
                    <div
                        className={
                            item.backgroundColor ? item.backgroundColor : ''
                        }
                        data-has-icon
                        data-icon-has-background={!!item.backgroundColor}
                    >
                        <Image
                            src={item.image.src}
                            width={item.image.width}
                            height={item.image.height}
                            alt={item.label || ''}
                        />
                    </div>
                    <div className={classNames(styles['info'], 'lg:pl-4')}>
                        <span>{item.label}</span>
                        <p>{item.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default InfoGrid;
